import { createAction, ActionType, createReducer } from 'typesafe-actions';

interface VERSION {
  version: string;
}

const initialState: VERSION = {
  version: '',
};

// UUID 확인, UUID 변경
export const CHANGE_VERSION = 'UuidReducer/CHANGE_VERSION';

export const changeVersion = createAction(CHANGE_VERSION)<VERSION>();

export const actions = { changeVersion };

type VersionReducerActions = ActionType<typeof actions>;

const VersionReducer = createReducer<VERSION, VersionReducerActions>(initialState, {
  [CHANGE_VERSION]: (state, action) => {
    return {
      ...state,
      ...action.payload,
    };
  },
});

export default VersionReducer;
